<div class="flex items-center content-center">
    <span>{{ baseParams().valueFormatted }}</span>
    <img alt="Potential Duplicate" class="ml-4 size-8" [src]="customParams().src" />
</div>
